import type { AdminRole } from '@/lib/api-admin';

/**
 * ID50 배송비조건 관리 RBAC.
 *
 * be-shipping 계약: order-service SecurityConfig `/api/admin/v1/shipping/**` 매처가
 * SUPER_ADMIN / OPS_ADMIN / PRODUCT_MANAGER 를 허용한다. 단, FE `AdminRole` 열거에는
 * PRODUCT_MANAGER 가 존재하지 않으므로(작업지시서 역할군 ↔ order-service 역할군 매핑
 * 차이) overseas admin 과 동일하게 SUPER_ADMIN / OPS_ADMIN 로 게이팅한다. 상품 운영
 * 가시성을 위해 read 에는 MD_MANAGER 를 추가로 허용한다.
 */
export const SHIPPING_FEE_READ_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'MD_MANAGER',
];

export const SHIPPING_FEE_WRITE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
];
